// Central registry of AI-gated features.
// Add or remove entries here to control which surfaces show the consent gate.
export const AI_FEATURES = {
  chat: {
    id: 'chat',
    name: 'Daily Dialogue',
    tagline: 'Conversations grounded in your story',
    description: 'Your journal entries are used to give the AI context for a meaningful, personal conversation. Names, places, and themes from what you write are organised over time so the chat can reply with continuity — like a friend who remembers what you have shared.',
  },
  companion: {
    id: 'companion',
    name: 'Companion Card',
    tagline: 'Picks up where you left off',
    description: 'On Home, your most recent entry from the last few days is read by AI to write one line about it and one question to carry it forward. Open Dialogue starts a chat with that question. If an entry reads as a hard moment, the card stays general instead.',
  },
  quote: {
    id: 'quote',
    name: 'Personal Reflections',
    tagline: 'A thought drawn from your own words',
    description: 'A short reflection is generated each day from your recent writing.',
  },
  smartReflections: {
    id: 'smartReflections',
    name: 'Smart Reflections',
    tagline: 'A short note back, after you write',
    description: 'Once a day, what you wrote is read by AI to write you a few sentences back — what you seemed to be working through, and one small thing to come back to. It is shown once and never scored, rated, or compared to anyone else.',
  },
  deepInsights: {
    id: 'deepInsights',
    name: 'Deep Insights',
    tagline: 'Patterns in your emotional landscape',
    description: 'Your journal entries are analysed to surface emotional patterns over time.',
  },
  pairs: {
    id: 'pairs',
    name: 'Language Patterns',
    tagline: 'Words you reach for together',
    description: 'Word-pair patterns are derived from your journal to show recurring themes.',
  },
  voiceTranscription: {
    id: 'voiceTranscription',
    name: 'Voice to Text',
    tagline: 'Speak naturally, write effortlessly',
    description: 'Audio you record is stored encrypted and sent to a transcription service to convert your speech into text. You can delete any recording at any time.',
  },
};

